module.exports = __webpack_public_path__ + "8afc5c8f4531979d11d9d8ffe0cc53e7.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Light.ttf
// module id = 967
// module chunks = 0